package modysy.menu

import modysy.InputHandler
import modysy.datastructures.Vector2
import org.scalajs.dom

/**
  * Button which is rendered on a Canvas
  * If button is clicked, an action is performed
  *
  * @param x x-Position of button on canvas
  * @param y y-Position of button on canvas
  */
abstract class AbstractButton(x: Double, y: Double) {

  protected var _mousePointing: Boolean = false
  protected var _ready: Boolean = false
  protected var fingerPointing: Boolean = false

  protected def pointOnButton(point: Vector2): Boolean

  def mousePointing: Boolean = _mousePointing

  var action: () => Unit = () => {}
  var isEnabled: () => Boolean = () => {
    true
  }

  /**
    * Displays the Button
    *
    * @param ctx The CanvasRenderingContext2D of the canvas
    */
  def render(ctx: dom.CanvasRenderingContext2D): Unit

  private var screenToCanvasWorkAround: Vector2 => Vector2 = { v: Vector2 =>
    v
  } // TODO so ugly, so sad!

  val onTouchStart: dom.TouchEvent => Unit = (event: dom.TouchEvent) => {

    if (isEnabled() && event.touches.length == 1) {
      val touchPoint = new Vector2(
        event.touches.item(0).clientX,
        event.touches.item(0).clientY
      )

      fingerPointing = pointOnButton(this.screenToCanvasWorkAround(touchPoint)) // TODO so ugly, so sad!
    } else {
      fingerPointing = false
    }
  }

  val onTouchMove: dom.TouchEvent => Unit = (event: dom.TouchEvent) => {
    if (isEnabled() && event.touches.length == 1) {
      val touchPoint = new Vector2(
        event.touches.item(0).clientX,
        event.touches.item(0).clientY
      )
      fingerPointing = pointOnButton(this.screenToCanvasWorkAround(touchPoint)) // TODO so ugly, so sad!
    } else {
      fingerPointing = false
    }
  }

  val onTouchEnd: dom.TouchEvent => Unit = (event: dom.TouchEvent) => {
    if (isEnabled() && fingerPointing)
      action()
  }

  def enableTouch(inputs: InputHandler): Unit = {
    this.screenToCanvasWorkAround = inputs.screenToCanvasWorkAround // TODO so ugly, so sad!
    inputs.bindOnTouchStartEvents(onTouchStart)
    inputs.bindOnTouchMoveEvents(onTouchMove)
    inputs.bindOnTouchEndEvents(onTouchEnd)
  }

  /**
    * Performs any neccessary updates of the button
    *
    * @param inputs
    */
  def update(inputs: InputHandler): Unit = {

    if (!isEnabled()) return

    if (inputs.mouseCanvasPos.isDefined) {
      _mousePointing = pointOnButton(inputs.mouseCanvasPos.get)
    } else {
      _mousePointing = false
    }

    if (!_mousePointing)
      _ready = false

    if (_mousePointing && !inputs.mouseIsDown)
      _ready = true

    if (_ready && inputs.mouseIsDown)
      action.apply()

  }

}



// WEBPACK FOOTER //
// /home/gitlab-runner/builds/2d4fb5cd/0/mtv-pr-2018/modysy-product/src/main/scala/modysy/menu/AbstractButton.scala